import { isAutherized } from './keycloak';

export default function AuthorizedFunction(roles) {
    return isAutherized(roles);
}